module.exports = __webpack_public_path__ + "847438f08bcf118549a5b9bc68b6dcf3.pdf";